

export const ANIME_EDITABLE = [
  'type',
  'format',
  'status',
  'season_year',
  'cover_color',
  'popularity',
  'is_adult',
] as const;

export const ANIME_GRANTABLE = [
  'title',
  'title_english',
  'title_native',
  'cover_url',
  'cover_medium_url',
  'banner_url',
] as const;


export const ANIME_SYSTEM = ['id', 'favourites', 'rank', 'character_count', 'synced_at', 'created_at'] as const;

export const CHARACTER_EDITABLE = ['role', 'rarity', 'value', 'is_obtainable'] as const;

export const CHARACTER_GRANTABLE = ['name', 'name_native', 'image_url', 'image_medium_url', 'favourites'] as const;

export const CHARACTER_SYSTEM = ['id', 'anime_id', 'synced_at', 'created_at'] as const;

export type CatalogEntity = 'anime' | 'character';
export type CatalogFieldKind = 'editable' | 'grantable' | 'system' | 'unknown';

const ANIME_OVERRIDE = new Set<string>([
  ...ANIME_EDITABLE,
  ...ANIME_GRANTABLE,
  ...ANIME_SYSTEM.filter((field) => field !== 'id' && field !== 'character_count'),
]);
const CHARACTER_OVERRIDE = new Set<string>([
  ...CHARACTER_EDITABLE,
  ...CHARACTER_GRANTABLE,
  ...CHARACTER_SYSTEM.filter((field) => field !== 'id' && field !== 'anime_id'),
]);

export function catalogOverrideFields(entity: CatalogEntity): ReadonlySet<string> {
  return entity === 'anime' ? ANIME_OVERRIDE : CHARACTER_OVERRIDE;
}

export function catalogFieldKind(entity: CatalogEntity, field: string): CatalogFieldKind {
  if (entity === 'anime') {
    if ((ANIME_SYSTEM as readonly string[]).includes(field)) return 'system';
    if ((ANIME_EDITABLE as readonly string[]).includes(field)) return 'editable';
    if ((ANIME_GRANTABLE as readonly string[]).includes(field)) return 'grantable';
    return 'unknown';
  }
  if ((CHARACTER_SYSTEM as readonly string[]).includes(field)) return 'system';
  if ((CHARACTER_EDITABLE as readonly string[]).includes(field)) return 'editable';
  if ((CHARACTER_GRANTABLE as readonly string[]).includes(field)) return 'grantable';
  return 'unknown';
}


export const CATALOG_FIELD_LABELS_FR: Record<string, string> = {
  id: 'identifiant',
  title: 'nom',
  title_english: 'nom anglais',
  title_native: 'nom original',
  cover_url: 'image',
  cover_medium_url: 'image moyenne',
  banner_url: 'bannière',
  favourites: 'favoris',
  name: 'nom',
  name_native: 'nom original',
  image_url: 'image',
  image_medium_url: 'image moyenne',
};

// Pseudo-field stored in Staff_Permission_Requests: the requester asks for the entry to be deleted.
export const CATALOG_DELETE_FIELD = '__delete';

export function catalogFieldLabelFr(field: string): string {
  return CATALOG_FIELD_LABELS_FR[field] ?? field;
}
